// extracted by mini-css-extract-plugin
export default {"characteristicTable":"characteristicTable_BenchmarkGenericQuestionsTableHOC-module__M65i"};